/* tslint:disable */
import {
  Image,
  QuickArt,
  Audio,
  Feed,
  Video,
  Player,
  Screen,
  Library
} from '../index';

declare var Object: any;
export interface TagInterface {
  "name": string;
  "tagType": string;
  "id"?: number;
  "libraryId"?: string;
  images?: Image[];
  quickArts?: QuickArt[];
  audios?: Audio[];
  feeds?: Feed[];
  videos?: Video[];
  players?: Player[];
  screens?: Screen[];
  library?: Library;
}

export class Tag implements TagInterface {
  "name": string;
  "tagType": string;
  "id": number;
  "libraryId": string;
  images: Image[];
  quickArts: QuickArt[];
  audios: Audio[];
  feeds: Feed[];
  videos: Video[];
  players: Player[];
  screens: Screen[];
  library: Library;
  constructor(data?: TagInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tag`.
   */
  public static getModelName() {
    return "Tag";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Tag for dynamic purposes.
  **/
  public static factory(data: TagInterface): Tag{
    return new Tag(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Tag',
      plural: 'Tags',
      path: 'Tags',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "tagType": {
          name: 'tagType',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "libraryId": {
          name: 'libraryId',
          type: 'string'
        },
      },
      relations: {
        images: {
          name: 'images',
          type: 'Image[]',
          model: 'Image',
          relationType: 'hasMany',
          modelThrough: 'TagImage',
          keyThrough: 'imageId',
          keyFrom: 'id',
          keyTo: 'tagId'
        },
        quickArts: {
          name: 'quickArts',
          type: 'QuickArt[]',
          model: 'QuickArt',
          relationType: 'hasMany',
          modelThrough: 'TagQuickArt',
          keyThrough: 'quickArtId',
          keyFrom: 'id',
          keyTo: 'tagId'
        },
        audios: {
          name: 'audios',
          type: 'Audio[]',
          model: 'Audio',
          relationType: 'hasMany',
          modelThrough: 'TagAudio',
          keyThrough: 'audioId',
          keyFrom: 'id',
          keyTo: 'tagId'
        },
        feeds: {
          name: 'feeds',
          type: 'Feed[]',
          model: 'Feed',
          relationType: 'hasMany',
          modelThrough: 'TagFeed',
          keyThrough: 'feedId',
          keyFrom: 'id',
          keyTo: 'tagId'
        },
        videos: {
          name: 'videos',
          type: 'Video[]',
          model: 'Video',
          relationType: 'hasMany',
          modelThrough: 'TagVideo',
          keyThrough: 'videoId',
          keyFrom: 'id',
          keyTo: 'tagId'
        },
        players: {
          name: 'players',
          type: 'Player[]',
          model: 'Player',
          relationType: 'hasMany',
          modelThrough: 'TagPlayer',
          keyThrough: 'playerId',
          keyFrom: 'id',
          keyTo: 'tagId'
        },
        screens: {
          name: 'screens',
          type: 'Screen[]',
          model: 'Screen',
          relationType: 'hasMany',
          modelThrough: 'TagScreen',
          keyThrough: 'screenId',
          keyFrom: 'id',
          keyTo: 'tagId'
        },
        library: {
          name: 'library',
          type: 'Library',
          model: 'Library',
          relationType: 'belongsTo',
                  keyFrom: 'libraryId',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Tag.ts